import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MdLocationPin } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import { Link, useLocation } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { getNewsListFormData } from "../../services/routes.services";
import constants from "../../services/constants";
import dateFormat from 'dateformat';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { GrFormNextLink, GrFormPreviousLink  } from "react-icons/gr";
const NewsComponent = () => {
    const smoothScroll = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };
    const [getAllData, setGetAllData] = useState(null);
    const [cityOptions, setCityOptions] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [selectedYear, setSelectedYear] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    let navigat = useLocation();
    const currentPath = navigat.pathname;
    const itemsPerPage = currentPath === '/' ? 3 : 12;

    useEffect(() => {
        getNewsListFormData()
            .then((res) => {
                const newsData = res.data.news;
                setGetAllData(newsData);

                // Extract unique cities from the news data
                const uniqueCities = Array.from(new Set(newsData.map(item => item.location)));
                setCityOptions(uniqueCities);

                // Extract unique years from the newsDate field
                const uniqueYears = Array.from(new Set(newsData.map(item => new Date(item.newsDate).getFullYear())));
                setYearOptions(uniqueYears);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleCityChange = (event) => {
        setSelectedCity(event.target.value);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    var lastElement = '';
    var isAfterTargetDate = '';
    if (getAllData != null) {
        if (getAllData.length > 0) {
            lastElement = getAllData[getAllData.length - 1];
            const currentDate = new Date();
            const targetDate = new Date(lastElement.endDate);
            isAfterTargetDate = currentDate > targetDate;
        }
    }

    const filteredNews = getAllData
        ? getAllData.filter(item => {
            const newsYear = new Date(item.newsDate).getFullYear();
            const matchYear = selectedYear ? newsYear === parseInt(selectedYear) : true;
            const matchCity = selectedCity ? item.location === selectedCity : true;
            const matchSearch = searchQuery
                ? item.title.toLowerCase().includes(searchQuery.toLowerCase())
                : true;
                return matchYear && matchCity && matchSearch;
        })
        : [];
// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredNews.slice(indexOfFirstItem, indexOfLastItem);

const totalPages = Math.ceil(filteredNews.length / itemsPerPage);

const paginate = (pageNumber) => setCurrentPage(pageNumber);
const goToFirstPage = () => setCurrentPage(1);
const goToLastPage = () => setCurrentPage(totalPages);
const goToPreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
};

const goToNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
};
    return (
        <div>
            <BreadcrumbComponent home='Home' listOne="News" />
        <div className={Style.eventSec + ' ' + Style.componentsSpace + ' ' + Style.pageHideComp}>
            <Container>
                <Row>
                    <Col md={12}>
                        <div className={Style.sectionTitle}>
                            <h2>News</h2>
                        </div>
                    </Col>
                    <Col md={12} className={Style.searchArea}>
                        <div className={Style.searchContainer}>
                            <div className={Style.searchInput}>
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    placeholder="Search by title"
                                />
                                <button type="button" onClick={smoothScroll}>
                                    Search
                                </button>
                            </div>
                            <div className={Style.byYear}>
                                <select onChange={handleYearChange} value={selectedYear}>
                                    <option value="">Year</option>
                                    {yearOptions.map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                                <select onChange={handleCityChange} value={selectedCity}>
                                    <option value="">City</option>
                                    {cityOptions.map(city => (
                                        <option key={city} value={city}>{city}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    {lastElement && (
                        <Col>
                            <div className={Style.eventContainer}>
                                <div className={Style.eventElement}>
                                    <div className={Style.eventImg}>
                                        <img src={constants.IMAGE_BASE_URL + "news/" + lastElement.image} />
                                    </div>
                                    <div className={Style.eventDetail}>
                                        <h3>{dateFormat(lastElement.newsDate, "dd mmmm yyyy | dddd")}</h3>
                                        <h4><Link to={`/news-detail/${lastElement.newsSlug}`} onClick={smoothScroll}>{lastElement.title}</Link></h4>
                                        <Link to={`/news-detail/${lastElement.newsSlug}`} onClick={smoothScroll} className={Style.simpleBlueBtn}>READ MORE <IoArrowForwardCircleOutline className={Style.mediaLink} /></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
                <Row className={Style.rowSpace}>
                    <Col md={12} className={Style.pageSubTitle}>
                        <h3>ALL NEWS</h3>
                    </Col>
                    {filteredNews && currentItems.length > 0 ? (
                        currentItems.map((value, index) => (
                            <Col md={4} key={index}>
                            <div className={Style.mediaList}>
                                <div className={Style.mediaImg}>
                                {value.image !== 'null' ? (
                                    <img src={constants.IMAGE_BASE_URL + "news/" + value.image} className={Style.coverImg} />
                                ) : (
                                    <img src={require('../../assest/images/no-img.jpg')} className={Style.coverImg} />
                                )}
                                <Link className={Style.eventTag + ' ' + Button.brownBtn}>CONCLAVE & EXHIBHITION</Link>
                                </div>
                                <div className={Style.mediaDetail}>
                                <h6>{dateFormat(value.newsDate, "dd mmmm yyyy ")}</h6>
                                <h4><Link to={`/news-detail/${value.newsSlug}`} onClick={smoothScroll}>{value.title}</Link></h4>
                                <Link to={`/news-detail/${value.newsSlug}`} onClick={smoothScroll}><IoArrowForwardCircleOutline className={Style.mediaLink} /></Link>
                                </div>
                            </div>
                            </Col>
                        ))
                        ) : (
                        <Col md={12} className={Style.noDataFound}>
                            <p>Data not found.</p>
                        </Col>
                        )}

                       {/* Pagination */}
                  {filteredNews.length > itemsPerPage && (
                    
                    <div className={Button.flextCenterBtn + " " + Style.pagging}>
                         <button onClick={goToFirstPage} disabled={currentPage === 1}>&laquo;</button>
                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>&lsaquo;</button>
                        {Array.from({ length: totalPages }, (_, index) => index + 1).slice(Math.max(0, currentPage - 2), currentPage + 1).map((number) => (
                            <button key={number} onClick={() => paginate(number)} className={currentPage === number ? Style.activePage : Style.inactivePage}>{number}</button>
                        ))}
                        <button onClick={goToNextPage} disabled={currentPage === totalPages}>&rsaquo;</button>
                        <button onClick={goToLastPage} disabled={currentPage === totalPages}>&raquo;</button>
                    </div>
              
        )}
                </Row>
                <Row>
                    <Col className={Style.pageLink}>
                        <div className={Button.flextCenterBtn + ' ' + Style.marginUp60}>
                            <Link to='/news' onClick={smoothScroll} className={Button.brownBorderBtn}>See All News</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        </div>
    )
}

export default NewsComponent;
